const TOOLS = {
  BOLD: 'BOLD',
  ITALIC: 'ITALIC',
  UNDERLINE: 'UNDERLINE',
  STRIKE: 'STRIKE',
  LINK: 'LINK',
  LIST: {
    BULLET: 'BULLET',
    NUMERIC: 'NUMERIC'
  },
  HEADER: {
    NORMAL: 'NORMAL',
    H3: 'H3',
    H1: 'H1'
  },
  ALIGN: {
    LEFT: 'LEFT',
    CENTER: 'CENTER',
    RIGHT: 'RIGHT',
    JUSTIFY: 'JUSTIFY'
  },
  IMAGE: 'IMAGE'
}

const CONFIG = {
  history: {
    undo: [],
    redo: []
  }
}

export default {
  TOOLS,
  CONFIG
}
